export default __webpack_public_path__ + "static/media/wheel_1.a00560e8.svg";